export enum OperationStatus {
  DONE = "DONE",
  CANCELLED = "CANCELLED",
  EXPIRED = "EXPIRED",
  FAILED = "FAILED",
}
